import React from 'react';

// Ashoka Chakra — the 24-spoke navy wheel from the Indian national flag.
// Rendered as an inline SVG so it scales crisply and inherits sizing.
function Chakra({ size = 24, color = '#000080', className }) {
  const spokes = Array.from({ length: 24 });
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="50" cy="50" r="46" fill="none" stroke={color} strokeWidth="4" />
      <circle cx="50" cy="50" r="6.5" fill={color} />
      {spokes.map((_, i) => {
        const angle = (i * 15 * Math.PI) / 180;
        const x2 = 50 + 44 * Math.cos(angle);
        const y2 = 50 + 44 * Math.sin(angle);
        return (
          <line
            key={i}
            x1="50"
            y1="50"
            x2={x2}
            y2={y2}
            stroke={color}
            strokeWidth="1.6"
          />
        );
      })}
    </svg>
  );
}

export default Chakra;
